import { render, staticRenderFns } from "./LabProductItem.vue?vue&type=template&id=011fb0f0"
import script from "./LabProductItem.vue?vue&type=script&lang=js"
export * from "./LabProductItem.vue?vue&type=script&lang=js"
import style0 from "./LabProductItem.vue?vue&type=style&index=0&id=011fb0f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports